<ng-container *ngIf="showBackLink">
  <a href="#" (click)="goBack($event)" class="govuk-back-link">Back</a>
</ng-container>
